import { useMemo } from 'react';
import moment from 'moment';

const getDuration = DateClose => {
  const closingDate = moment.utc(DateClose).local();
  return moment.duration(closingDate.diff(moment()));
};

export const useProjectClosingDate = DateClose => {
  const closingInfo = useMemo(() => {
    const duration = getDuration(DateClose);
    const isClosedProject = duration.as('milliseconds') <= 0;
    const isClosingSoon = !isClosedProject && duration.as('hours') < 24;

    return {
      isOpenProject: !isClosedProject,
      isClosingSoon,
      remaining: {
        days: Math.round(duration.as('days')),
        hours: moment.utc(duration.as('milliseconds')).format('H[h] m[m] s[s]'),
      },
    };
  }, [DateClose]);

  return closingInfo;
};
